import React from "react";
import CrudList from "@/components/CrudList";

export default function Sparepart() {
  return (
    <CrudList
      title="Sparepart"
      subtitle="Stok sparepart alat berat"
      endpoint="/spareparts"
      exportModule="spareparts"
      columns={[
        { key: "code", label: "Kode" },
        { key: "name", label: "Nama" },
        { key: "stock", label: "Stok" },
        { key: "unit", label: "Unit" },
        { key: "min_stock", label: "Min. Stok" },
        { key: "price", label: "Harga", render: (r) => "Rp " + (r.price || 0).toLocaleString('id-ID') },
      ]}
      fields={[
        { key: "code", label: "Kode", required: true, placeholder: "SP-001" },
        { key: "name", label: "Nama", required: true },
        { key: "stock", label: "Stok", type: "number" },
        { key: "unit", label: "Unit", placeholder: "pcs / liter / kg" },
        { key: "min_stock", label: "Min. Stok", type: "number" },
        { key: "price", label: "Harga (Rp)", type: "number" },
      ]}
    />
  );
}
